import styled from 'styled-components'

export const Iframe = styled.iframe`
  box-shadow: 0 10px 35px 0 rgba(0, 0, 0, 0.15);
`
